import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { renderSelect as RenderSelect } from 'shared/forms/RenderSelect';

import { changeTenderResponseStatus } from './ducks';

const BLANK_OPTION = { value: null, label: 'No Status Selected' };

class TenderResponseStatusForm extends React.Component {
  handleChange = selectedOption => {
    const { id, isDisabled } = this.props;

    if (isDisabled) {
      return;
    }

    const { extraActions } = this.props;

    this.props.changeTenderResponseStatus(id, selectedOption, extraActions);
  };

  render() {
    const {
      value,
      constants,
      className,
      isDisabled,
      defaultValue
    } = this.props;

    let tenderResponseStatusChoices = _.get(
      constants,
      'users.TENDER_RESPONSE_STATUS_CHOICES'
    );

    tenderResponseStatusChoices = [
      BLANK_OPTION,
      ...tenderResponseStatusChoices
    ];

    return (
      <RenderSelect
        value={value}
        isClearable={false}
        isDisabled={isDisabled}
        className={className}
        defaultValue={defaultValue}
        onChange={this.handleChange}
        options={tenderResponseStatusChoices}
      />
    );
  }
}

const mapStateToProps = state => {
  const { constants } = state.constants;

  return { constants };
};

const mapDispatchToProps = { changeTenderResponseStatus };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TenderResponseStatusForm);
